import { SERVICE_KIND_OPERATION } from './surgeryService';

export const PHLEBOLOGY_OPERATION_DOCTOR_PERCENT = 65;

export const PAYROLL_OPERATION_EXPENSE_FIELDS = [
  { key: 'supplies', label: 'Расходники', snake: 'operation_expense_supplies' },
  { key: 'tax', label: 'Налоги', snake: 'operation_expense_tax' },
  { key: 'nurse', label: 'Медсестра', snake: 'operation_expense_nurse' },
];

export const OPERATION_EXPENSE_DETAIL_FIELDS = [
  { key: 'analysis', label: 'Анализы', snake: 'operation_expense_analysis' },
  { key: 'doctor', label: 'Расходы врача (+ к ЗП)', snake: 'operation_expense_doctor' },
  { key: 'clinic', label: 'Расходы клиники', snake: 'operation_expense_clinic' },
  { key: 'other', label: 'Прочие', snake: 'operation_expense_other' },
  { key: 'kkm', label: 'ККМ', snake: 'operation_expense_kkm' },
];

export const OPERATION_EXPENSE_FIELDS = [...PAYROLL_OPERATION_EXPENSE_FIELDS, ...OPERATION_EXPENSE_DETAIL_FIELDS];

export function defaultOperationExpenses() {
  return {
    supplies: '',
    tax: '',
    analysis: '',
    doctor: '',
    nurse: '',
    clinic: '',
    other: '',
    kkm: '',
  };
}

export function operationExpensesFromLine(row) {
  const src = row?.operationExpenses || {};
  return {
    supplies: src.supplies ?? '',
    tax: src.tax ?? '',
    analysis: src.analysis ?? '',
    doctor: src.doctor ?? '',
    nurse: src.nurse ?? '',
    clinic: src.clinic ?? '',
    other: src.other ?? '',
    kkm: src.kkm ?? '',
  };
}

export function isPhlebologyOperationService(serviceOrName) {
  const name =
    typeof serviceOrName === 'string'
      ? serviceOrName
      : serviceOrName?.name ?? serviceOrName?.serviceName ?? serviceOrName?.service_name ?? '';
  const kind =
    typeof serviceOrName === 'object'
      ? serviceOrName?.serviceKind ?? serviceOrName?.service_kind ?? ''
      : '';
  const normalized = String(name).toLowerCase();
  if (!normalized.includes('флеболог')) return false;
  if (kind && kind !== SERVICE_KIND_OPERATION) return false;
  return true;
}

export function isPayrollOperationService(serviceOrName) {
  const name =
    typeof serviceOrName === 'string'
      ? serviceOrName
      : serviceOrName?.name ?? serviceOrName?.serviceName ?? serviceOrName?.service_name ?? '';
  const kind =
    typeof serviceOrName === 'object'
      ? serviceOrName?.serviceKind ?? serviceOrName?.service_kind ?? ''
      : '';
  if (kind === SERVICE_KIND_OPERATION) return true;
  return String(name).toLowerCase().includes('операц');
}

export function resolveOperationDoctorPercent(serviceOrName, fallback = PHLEBOLOGY_OPERATION_DOCTOR_PERCENT) {
  if (typeof serviceOrName === 'object' && serviceOrName != null) {
    const raw = serviceOrName?.doctorProfitPercent ?? serviceOrName?.doctor_profit_percent;
    if (raw != null && raw !== '') return Math.max(0, Math.min(100, Number(raw) || 0));
  }
  return fallback;
}

function readExpense(expenses, key) {
  return Math.max(0, Number(expenses?.[key]) || 0);
}

export function calcOperationSplit(amount, expenses = {}, doctorPercent = PHLEBOLOGY_OPERATION_DOCTOR_PERCENT) {
  const base = Math.max(0, Number(amount) || 0);
  const analysis = readExpense(expenses, 'analysis');
  const doctorExpense = readExpense(expenses, 'doctor');
  const nurse = readExpense(expenses, 'nurse');
  const clinicExpense = readExpense(expenses, 'clinic');
  const other = readExpense(expenses, 'other');
  const kkm = readExpense(expenses, 'kkm');
  const supplies = readExpense(expenses, 'supplies');
  const tax = readExpense(expenses, 'tax');

  const totalExpenses = Math.round((analysis + doctorExpense + nurse + clinicExpense + other + kkm + supplies + tax) * 100) / 100;
  const clean = Math.max(0, Math.round((base - totalExpenses) * 100) / 100);
  const percent = Math.max(0, Math.min(100, Number(doctorPercent) || 0));
  // % от чистой + компенсация «Расходы врача»
  const doctorPayout = Math.round((clean * (percent / 100) + doctorExpense) * 100) / 100;
  const clinicIncome = Math.round((clean * ((100 - percent) / 100) + clinicExpense + kkm) * 100) / 100;

  return {
    amount: base,
    totalExpenses,
    cleanProfit: clean,
    doctorPayout,
    nursePayout: nurse,
    clinicIncome,
    doctorPercent: percent,
  };
}

export function calcPhlebologyOperationSplit(amount, expenses = {}) {
  return calcOperationSplit(amount, expenses, PHLEBOLOGY_OPERATION_DOCTOR_PERCENT);
}

export function buildOperationExpensePayload(expenses = {}) {
  return {
    operation_expense_supplies: readExpense(expenses, 'supplies'),
    operation_expense_tax: readExpense(expenses, 'tax'),
    operation_expense_analysis: readExpense(expenses, 'analysis'),
    operation_expense_doctor: readExpense(expenses, 'doctor'),
    operation_expense_nurse: readExpense(expenses, 'nurse'),
    operation_expense_clinic: readExpense(expenses, 'clinic'),
    operation_expense_other: readExpense(expenses, 'other'),
    operation_expense_kkm: readExpense(expenses, 'kkm'),
  };
}

export function hasOperationDetailExpenses(expenses = {}) {
  return OPERATION_EXPENSE_DETAIL_FIELDS.some((field) => readExpense(expenses, field.key) > 0);
}
